import ctl from "@netlify/classnames-template-literals";

export const mainContent = ctl(`
  flex
  flex-col
  h-full
  max-h-[calc(100vh_-_8rem)]
  md:max-h-screen
`);
